if (!customElements.get("variant-availability")) {
  customElements.define("variant-availability", class VariantAvailability extends HTMLElement {
      static STATES_BY_PRIORITY = ["in-stock", "preorder", "sold-out"];

      connectedCallback() {
        this.variantSelects = this.closest("variant-selects");
        if (!this.variantSelects) return;

        this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        this.legend = this.querySelector(".variant-availability__legend");
        // The sticky picker mirrors the main one, so only the main picker reports the selected variant state.
        this.stateContainer = this.variantSelects.dataset.sticky
          ? null
          : this.variantSelects.closest(".product-information, #Product-Drawer-Content");

        this.variantSelects.addEventListener("change", this.update);
        document.addEventListener("product:variant-change", this.update);
        window.addEventListener("pageshow", this.update);
        this.update();
      }

      disconnectedCallback() {
        this.variantSelects?.removeEventListener("change", this.update);
        document.removeEventListener("product:variant-change", this.update);
        window.removeEventListener("pageshow", this.update);
      }

      update = () => {
        const fieldsets = Array.from(this.variantSelects.querySelectorAll("fieldset"));
        const selectedOptions = fieldsets.map((fieldset) => {
          const select = fieldset.querySelector("select");
          if (select) return select.value;

          return fieldset.querySelector("input:checked")?.value ?? null;
        });
        const shownStates = new Set();

        fieldsets.forEach((fieldset, optionIndex) => {
          fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
            // Same hierarchy as the theme: a value is evaluated against the options selected before it,
            // so switching Width recalculates every Size, while Width itself reflects all of its sizes.
            const matchingVariants = this.variants.filter(
              (variant) =>
                variant.options[optionIndex] === input.value &&
                selectedOptions.slice(0, optionIndex).every((value, index) => variant.options[index] === value)
            );
            const state = this.getBestState(matchingVariants);

            input.classList.toggle("is-preorder", state === "preorder");
            input.classList.toggle("is-sold-out", state === "sold-out");
            this.setDescription(input, state);
            shownStates.add(state);
          });
        });

        if (this.stateContainer) {
          const currentVariant = this.variants.find((variant) =>
            variant.options.every((value, index) => value === selectedOptions[index])
          );
          this.stateContainer.dataset.variantState = currentVariant ? currentVariant.state : "sold-out";
        }

        this.updateLegend(shownStates);
      };

      getBestState(variants) {
        return (
          VariantAvailability.STATES_BY_PRIORITY.find((state) => variants.some((variant) => variant.state === state)) ||
          "sold-out"
        );
      }

      setDescription(input, state) {
        const description = document.getElementById(`VariantAvailability-${this.dataset.section}-${state}`);

        if (description) {
          input.setAttribute("aria-describedby", description.id);
        } else {
          input.removeAttribute("aria-describedby");
        }
      }

      updateLegend(shownStates) {
        if (!this.legend) return;

        let hasVisibleItems = false;
        this.legend.querySelectorAll("[data-state]").forEach((item) => {
          item.hidden = !shownStates.has(item.dataset.state);
          hasVisibleItems = hasVisibleItems || !item.hidden;
        });
        this.legend.hidden = !hasVisibleItems;
      }
    }
  );
}
